<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ory8hX/cover.jpg?1732976220461" alt="This image is the cover for the book Divine Design"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Divine Design
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman who wants a baby comes up with the perfect plan—but destiny has other ideas . . . </b><br/><br/>When Meghan Shay crashes the male-dominated Physics Symposium at New York’s Essex House Hotel, she isn’t looking for a husband. She is looking for a perfect stranger with whom to share her bed for one night. Once he gives her what she wants, she will never see him again. The plan backfires when gorgeous Texas hunk Michael Ramsey shows up at her law firm.<br/><br/>For months, Michael has been searching for the beautiful redhead who gave him the most passionate night of his life—only to vanish into thin air. When fate brings them together once more, he is not about to let the woman who got away get away again. But what happens when he finds out Meghan is having his baby? Will the onetime Dallas bachelor give up his hard-won freedom for fatherhood . . . and wedlock?<br/><br/>This ebook features an extended biography of Mary Kay McComas.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Kay McComas
      </h2>
      
      <p class="authorDescription body article">Mary Kay McComas is an acclaimed romance novelist and the author of twenty-one short contemporary romances, five novellas, and two novels. McComas has received numerous honors and prizes for her work, including the Washington Romance Writers&rsquo; Outstanding Achievement Award and two Career Achievement Awards from <i>Romantic Times</i> (one for Best New Novel and another for Most Innovative Romance Series). She has recently contributed to Nora Roberts&rsquo;s J. D. Robb fantasy anthologies, with highly praised paranormal romance stories. McComas and her family live in Virginia&rsquo;s Shenandoah Valley.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6036818